import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BranchManagement = () => {
  const [branches, setBranches] = useState([]);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadBranches();
  }, []);

  const loadBranches = async () => {
    try {
      const res = await axios.get(`${API}/admin/branches`);
      setBranches(res.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    
    setLoading(true);
    try {
      await axios.post(`${API}/admin/branches`, { name: newName });
      toast.success('Şube eklendi');
      setNewName('');
      loadBranches();
    } catch (error) {
      toast.error('Hata oluştu');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API}/admin/branches/${id}`);
      toast.success('Şube silindi');
      loadBranches();
    } catch (error) {
      toast.error('Hata oluştu');
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Şube Yönetimi</h2>
      
      <Card className="mb-6">
        <CardContent className="p-6">
          <form onSubmit={handleAdd} className="flex gap-2">
            <Input
              placeholder="Şube adı (örn: Merkez, Şantiye-1)"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="flex-1"
            />
            <Button type="submit" disabled={loading}>
              <Plus className="h-4 w-4 mr-2" />
              Ekle
            </Button>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          {branches.length === 0 ? (
            <div className="text-center py-8 text-[hsl(var(--muted-foreground))]">
              Henüz şube eklenmedi
            </div>
          ) : (
            <div className="space-y-2">
              {branches.map(branch => (
                <div key={branch.id} className="flex items-center justify-between p-3 border border-[hsl(var(--border))] rounded-md">
                  <span className="font-medium">{branch.name}</span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleDelete(branch.id)}
                    className="text-[hsl(var(--destructive))]"
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BranchManagement;
